module.exports = __webpack_public_path__ + "img/utilityvalvac_parked.7d9a63ba.svg";